import { render, staticRenderFns } from "./CadastroProfissionais.vue?vue&type=template&id=649d4220&scoped=true"
import script from "./CadastroProfissionais.vue?vue&type=script&lang=js"
export * from "./CadastroProfissionais.vue?vue&type=script&lang=js"
import style0 from "./CadastroProfissionais.vue?vue&type=style&index=0&id=649d4220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d4220",
  null
  
)

export default component.exports